import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=f99ba084&"
import script from "./Home3.vue?vue&type=script&lang=js&"
export * from "./Home3.vue?vue&type=script&lang=js&"
import style0 from "./Home3.vue?vue&type=style&index=0&id=f99ba084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports